import React from 'react';
import { DoNotCallList } from '../../../../../../../types/do-not-call-list';

type IProps = {
  doNotCallList: DoNotCallList;
};

const TotalField: React.FC<IProps> = ({ doNotCallList: { totalCount } }) => (
  <p className="total-field">{totalCount}</p>
);

export default TotalField;
